import React from 'react'

const ListingActionPanel = ({ onDelete, onSubmit, isEditing, listingID }) => {
  return (
    <div className="columns is-gapless">
      <div className="column has-text-right">
        {listingID && (
          <button className="button is-danger" onClick={onDelete}>
            DELETE
          </button>
        )}{' '}
        <button
          className="button is-primary"
          onClick={onSubmit}
          type="submit"
          disabled={!isEditing}
        >
          SAVE
        </button>
      </div>
    </div>
  )
}

export default ListingActionPanel



// WEBPACK FOOTER //
// ./src/components/templates/listing-detail/ListingActionPanel.js